import { useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useAccount } from '../../context/account'
import { fb } from '../../firebase'
import { Interval } from '../../shared/stripe'
import { PromiseVoid } from '../../types'
import { usePopupMessage } from '../messenger'
import { SpinnerButton } from '../spinners'

type Props = {
  show: boolean
  onHide: () => PromiseVoid
  target: Interval
}

export const ChangePremiumPlanPopup = ({
  show,
  onHide: handleHide,
  target,
}: Props) => {
  const { account } = useAccount()
  const [changing, setChanging] = useState(false)
  const { setPopupMessage } = usePopupMessage()
  // プランに契約していない、Freeプラン、変更後のプランが現在のプランと同じ場合は何も表示しない
  if (!account || account.plan === 'Free' || account.plan_interval === target)
    return <></>
  return (
    <Modal show={show} onHide={handleHide} backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>プランの変更</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* 〇〇プランから〇〇プランに切り替える旨と金額の違いを表示、金額は年間はFigmaを参考に年間の金額も表示 */}
        {/* 以下の説明もいい感じに入れる */}
        <p>
          変更前のプランの契約の残っている場合は、残っている日数に応じて今後の支払いは自動で割引されます。割引した結果が0円以下である場合はお支払いは発生しません。
        </p>
        <SpinnerButton
          loading={changing}
          onClick={async () => {
            setChanging(true)
            await fb.call('changePremiumPlanPrice')({ interval: target })
            setChanging(false)
            setPopupMessage('プランの変更が完了しました。')
            await handleHide()
          }}
        >
          プランを変更する
        </SpinnerButton>
      </Modal.Body>
    </Modal>
  )
}
